import { render, staticRenderFns } from "./SaleDetailModal.vue?vue&type=template&id=6ab7f472&scoped=true"
import script from "./SaleDetailModal.vue?vue&type=script&lang=js"
export * from "./SaleDetailModal.vue?vue&type=script&lang=js"
import style0 from "./SaleDetailModal.vue?vue&type=style&index=0&id=6ab7f472&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ab7f472",
  null
  
)

export default component.exports